import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const KnowledgeAndExperienceSection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="knowledgeAndExperienceSection"
      title={t('client.client.knowledgeAndExperience.title')}
    >
      <FormContent {...formProps} />
    </Section>
  );
};
